import { AUTH_API_BASE, getApiErrorMessage, parseApiResponse } from '../config/apiConfig';

const API_BASE = AUTH_API_BASE;
const TOKEN_KEY = 'certificate_auth_token';
const USERNAME_KEY = 'certificate_auth_username';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  token?: string;
  username?: string;
  message?: string;
}

class AuthApi {
  async login(request: LoginRequest): Promise<LoginResponse> {
    const response = await fetch(`${API_BASE}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    const data = await parseApiResponse<LoginResponse>(response);

    if (!response.ok) {
      return {
        success: false,
        message: getApiErrorMessage(data, 'Login failed'),
      };
    }

    return (data as LoginResponse) || { success: false, message: 'Login failed' };
  }

  saveSession(token: string, username: string): void {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USERNAME_KEY, username);
  }

  clearSession(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USERNAME_KEY);
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  getUsername(): string | null {
    return localStorage.getItem(USERNAME_KEY);
  }
}

export const authApi = new AuthApi();
